<script>
export default {
  name: 'IcoReceiptItems',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#030309',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.75 2.5H7.5C3.75 2.5 2.5 4.7375 2.5 7.5V8.75V26.25C2.5 27.2875 3.675 27.875 4.5 27.25L6.6375 25.65C7.1375 25.275 7.8375 25.325 8.2875 25.775L10.3625 27.8625C10.85 28.35 11.65 28.35 12.1375 27.8625L14.2375 25.7625C14.675 25.325 15.375 25.275 15.8625 25.65L18 27.25C18.825 27.8625 20 27.275 20 26.25V5C20 3.625 21.125 2.5 22.5 2.5H8.75ZM7.4625 17.5125C6.775 17.5125 6.2125 16.95 6.2125 16.2625C6.2125 15.575 6.775 15.0125 7.4625 15.0125C8.15 15.0125 8.7125 15.575 8.7125 16.2625C8.7125 16.95 8.15 17.5125 7.4625 17.5125ZM7.4625 12.5125C6.775 12.5125 6.2125 11.95 6.2125 11.2625C6.2125 10.575 6.775 10.0125 7.4625 10.0125C8.15 10.0125 8.7125 10.575 8.7125 11.2625C8.7125 11.95 8.15 12.5125 7.4625 12.5125ZM15 17.2H11.25C10.7375 17.2 10.3125 16.775 10.3125 16.2625C10.3125 15.75 10.7375 15.325 11.25 15.325H15C15.5125 15.325 15.9375 15.75 15.9375 16.2625C15.9375 16.775 15.5125 17.2 15 17.2ZM15 12.2H11.25C10.7375 12.2 10.3125 11.775 10.3125 11.2625C10.3125 10.75 10.7375 10.325 11.25 10.325H15C15.5125 10.325 15.9375 10.75 15.9375 11.2625C15.9375 11.775 15.5125 12.2 15 12.2Z"
      :fill="color"
    />
    <path
      d="M22.5125 2.5V4.375C23.3375 4.375 24.125 4.7125 24.7 5.275C25.3 5.8875 25.625 6.675 25.625 7.5V10.525C25.625 11.45 25.2125 11.875 24.275 11.875H21.875V5.0125C21.875 4.6625 22.1625 4.375 22.5125 4.375V2.5ZM22.5125 2.5C21.125 2.5 20 3.625 20 5.0125V13.75H24.275C26.25 13.75 27.5 12.5 27.5 10.525V7.5C27.5 6.125 26.9375 4.875 26.0375 3.9625C25.125 3.0625 23.8875 2.5125 22.5125 2.5C22.525 2.5 22.5125 2.5 22.5125 2.5Z"
      :fill="color"
    />
  </svg>
</template>
